// services/AuthService.ts
const API_URL = import.meta.env.VITE_API_URL || "http://localhost:7845";

/**
 * Checks if the given email exists in the system
 * @param email user email
 * @returns true if exists, false otherwise
 */
export async function checkEmailExists(email: string): Promise<boolean> {
  const res = await fetch(`${API_URL}/api/user/${email}`, {
    method: "GET"
  });

  if (!res.ok) {
    throw new Error("Failed to verify email");
  }
  else{
    return true;
  }

  const data = await res.json();
  return data.exists; // boolean returned by backend
}
